import rest from "@/rest-client";
import createCustomSaveVuexModule from "@/store/customSaveStore";

export const managementAccount = createCustomSaveVuexModule({
  namespaced: true,
  path: "/management/account",
  actions: {
    async delete({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);

        const response = await rest.post("/management/account/delete", payload);
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
